export const figure18 = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Éthiopie'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2014','2016','2019']
    },
    labels: {
      	
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 2000,
      tickInterval: 500,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
      
    },
    legend: {
      enabled: false,
  },
    
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [539, 645, 629,]
    }, {
      name: 'Autres exploitations',
      data: [1191, 1581, 1526,]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [410, 455, 459,]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [583, 712, 699,]
    }]
  }

  